import { render, staticRenderFns } from "./classroom-summary-item.vue?vue&type=template&id=8b456fdc&"
import script from "./classroom-summary-item.vue?vue&type=script&lang=js&"
export * from "./classroom-summary-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports